var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ft-select",class:{'-placeholder': !_vm.label},on:{"click":_vm.onPicker}},[_vm._v(" "+_vm._s(_vm.label || _vm.info.placeholder)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }